const MONTHS_RU = [
    "ЯНВАРЯ",
    "ФЕВРАЛЯ",
    "МАРТА",
    "АПРЕЛЯ",
    "МАЯ",
    "ИЮНЯ",
    "ИЮЛЯ",
    "АВГУСТА",
    "СЕНТЯБРЯ",
    "ОКТЯБРЯ",
    "НОЯБРЯ",
    "ДЕКАБРЯ",
];

const WEEKDAYS_RU = ["ВС", "ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ"];

export const resolveNewsImageUrl = (url) => {
    if (!url) {
        return "";
    }
    if (url.startsWith("http://") || url.startsWith("https://")) {
        return url;
    }

    const base = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

    if (url.startsWith("/uploads/news/")) {
        return `${base}${url}`;
    }
    if (url.startsWith("/")) {
        return `${base}${url}`;
    }

    return `${base}/uploads/news/${url}`;
};

/** @deprecated используйте resolveNewsImageUrl */
export const resolveMediaUrl = resolveNewsImageUrl;

/** datetime-local → ISO с часовым поясом +03:00 */
export const formatNewsDateTimeForApi = (dateTime) => {
    if (!dateTime) {
        return "";
    }

    const value = dateTime.trim();
    if (/[zZ]$/.test(value) || /[+-]\d{2}:\d{2}$/.test(value)) {
        return value;
    }

    const base = value.length >= 16 ? value.slice(0, 16) : value;
    return `${base}:00+03:00`;
};

export const formatNewsItemForCard = (item) => {
    const date = new Date(item.dateTime);
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return {
        id: item.id,
        image: resolveMediaUrl(item.image_url),
        dayNumber: String(date.getDate()),
        month: MONTHS_RU[date.getMonth()],
        year: String(date.getFullYear()),
        day: WEEKDAYS_RU[date.getDay()],
        time: `${hours}:${minutes}`,
        title: item.description,
        href: item.link_url,
    };
};

/** API dateTime → значение для input datetime-local */
export const toDatetimeLocalValue = (dateTime) => {
    if (!dateTime) {
        return "";
    }
    const date = new Date(dateTime);
    if (Number.isNaN(date.getTime())) {
        return dateTime.slice(0, 16);
    }
    const pad = (n) => String(n).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const buildNewsFormData = ({ image, dateTime, description, link_url }) => {
    const formData = new FormData();
    if (image) {
        formData.append("image", image);
    }
    formData.append("dateTime", formatNewsDateTimeForApi(dateTime));
    formData.append("description", description);
    formData.append("link_url", link_url);
    return formData;
};
